import React from 'react';
import {Button as NativeButton} from 'native-base';
import {message} from './../../utils/messages';

interface Props {
  label: string;
  onPress: () => void;
  disabled?: boolean;
}

const Button = (props: Props) => {
  const {label, onPress: handleOnPress, disabled} = props;
  return (
    <NativeButton
      width="100%"
      borderRadius="10"
      backgroundColor="#0088FF"
      color="white"
      fontStyle="normal"
      fontWeight="extrabold"
      onPress={() => handleOnPress()}
      isDisabled={disabled}>
      {message(label)}
    </NativeButton>
  );
};

export default Button;
